import { Banner } from '@viewbid/ui';
import { CreateHomepageBanner201ResponseAllOfData } from '@viewbid/ts-angular-client';

// The API has no title/alt field for banners; use a generic accessible label.
const BANNER_ALT: string = 'Featured banner';

/**
 * Maps the public homepage-banner API payload to the `@viewbid/ui` `Banner`
 * model. `listActiveHomepageBanners` types its `data` as `Array<object>`, so we
 * cast to the typed banner shape. Banners without an image are skipped (the
 * image is the hero); banners without a `linkUrl` are left link-less and render
 * as a non-clickable image.
 */
export function mapHomepageBanners(data: object[] = []): Banner[] {
    return (data as CreateHomepageBanner201ResponseAllOfData[])
        .filter(
            (banner: CreateHomepageBanner201ResponseAllOfData) => !!banner.url,
        )
        .map(
            (banner: CreateHomepageBanner201ResponseAllOfData): Banner => ({
                id: banner.id ?? '',
                imageUrl: banner.url!,
                linkUrl: banner.linkUrl ?? undefined,
                label: BANNER_ALT,
            }),
        );
}
